// extracted by mini-css-extract-plugin
export default {"zoomControls":"Oca-z","zoomControlButton":"Pca-z","zoomBanner":"Qca-z","bannerButton":"Rca-z","imageButton":"Sca-z","zoom":"Tca-z","zoomContent":"Uca-z"};